var $d389dc1f54eb134c$exports = {};
function $d389dc1f54eb134c$var$_findHeaderElement() {
    const el = document.getElementsByTagName("header");
    return el.length > 0 ? el[0] : undefined;
}
function $d389dc1f54eb134c$var$_findHeaderBannerElement() {
    return document.getElementById("header-banner");
}
function $d389dc1f54eb134c$var$_initializeHeader(clearTimer, el) {
    const headerContainerEl = $d389dc1f54eb134c$var$_findHeaderElement();
    const headerBannerEl = $d389dc1f54eb134c$var$_findHeaderBannerElement();
    const headerTitlePageEls = headerContainerEl?.getElementsByClassName("page");
    if (el && headerContainerEl && headerTitlePageEls?.length === 1) {
        const range = document.createRange();
        const chars = el.textContent.length;
        const headerTitleEl = headerTitlePageEls[0];
        const textEl = el.childNodes[0];
        range.setStart(textEl, 0);
        range.setEnd(textEl, chars);
        const rect = range.getClientRects()[0];
        const headerRect = headerContainerEl.getBoundingClientRect();
        if (rect.bottom < headerRect.height) {
            headerTitleEl.textContent = el.textContent;
            headerTitleEl.classList.add("opacity-100");
            clearTimer(true, ()=>{
                headerTitleEl.classList.remove("opacity-100");
                headerTitleEl.classList.add("opacity-0");
            });
        } else if (rect.top > headerRect.height) {
            clearTimer(false);
            headerTitleEl.classList.remove("opacity-100");
            headerTitleEl.classList.add("opacity-0");
        }
    }
    if (window.scrollY == 0) {
        headerContainerEl?.classList.remove("scrolled");
        headerBannerEl?.classList.remove("scrolled");
    } else {
        headerContainerEl?.classList.add("scrolled");
        headerBannerEl?.classList.add("scrolled");
    }
}
function $d389dc1f54eb134c$var$_initializeMenu(offset) {
    // TODO: Detect scrollTo and run this method when completed
    // https://stackoverflow.com/a/53957448/1391492
    const menuItems = document.querySelectorAll("#main-menu a.menu-item");
    const menuItemCandidates = [];
    const urlPathName = new URL(window.location.href).pathname;
    for(let i = 0; i < menuItems.length; i++){
        const menuItem = menuItems[i];
        let href = menuItem.getAttribute("href");
        if (href?.startsWith("/")) href = href.substring(1);
        if (href === null || !href.startsWith("#")) continue;
        else if (href === "#") menuItemCandidates.push({
            menuItem: menuItem,
            element: document.documentElement
        });
        else {
            const element = document.querySelector(href);
            menuItemCandidates.push({
                menuItem: menuItem,
                element: element
            });
        }
    }
    var candidates = menuItemCandidates.filter((o)=>{
        if (!o.element) return false;
        var docScrollTop = Math.round(document.documentElement.scrollTop);
        var inViewport = docScrollTop + offset >= o.element.offsetTop;
        return inViewport;
    });
    if (candidates.length > 0) {
        for(let i = 0; i < menuItemCandidates.length; i++)$d389dc1f54eb134c$var$_markMenuItemInactive(menuItemCandidates[i].menuItem);
        if (urlPathName === "/") $d389dc1f54eb134c$var$_markMenuItemActive(candidates[candidates.length - 1]?.menuItem);
    }
}
function $d389dc1f54eb134c$var$_maxBy(x, y, valueSelector) {
    const xValue = valueSelector(x);
    const yValue = valueSelector(y);
    return xValue >= yValue ? x : y;
}
function $d389dc1f54eb134c$var$_markMenuItemActive(menuItem) {
    menuItem.classList.add("active");
}
function $d389dc1f54eb134c$var$_markMenuItemInactive(menuItem) {
    menuItem.classList.remove("active");
}
function $d389dc1f54eb134c$var$_isInViewport(element) {
    if (!element) return false;
    if (1 !== element.nodeType) return false;
    const html = document.documentElement;
    const rect = element.getBoundingClientRect();
    if (!rect) return false;
    const isInViewport = rect && rect.bottom >= 0 && rect.right >= 0 && rect.left <= html.clientWidth && rect.top <= html.clientHeight;
    if (!isInViewport) return false;
    return rect;
}
/** https://stackoverflow.com/a/12418814/1391492 */ function $d389dc1f54eb134c$var$_inViewport(element) {
    if (!element) return false;
    if (1 !== element.nodeType) return false;
    var html = document.documentElement;
    var rect = element.getBoundingClientRect();
    if (!rect) return false;
    return !!rect && rect.bottom >= 0 && rect.right >= 0 && rect.left <= html.clientWidth && rect.top <= html.clientHeight;
}
/** Wording for the "reason" the form handlers append to the query string on failure. */ const $d389dc1f54eb134c$var$FORM_ERROR_REASONS = {
    captcha: "Nepodarilo sa n\xe1m overi\u0165, \u017Ee ste \u010Dlovek.",
    rate_limit: "Z tejto adresy pri\u0161lo prive\u013Ea spr\xe1v. Sk\xfaste to pros\xedm o hodinu.",
    invalid_input: "Skontrolujte pros\xedm vyplnen\xe9 \xfadaje, najm\xe4 e-mailov\xfa adresu.",
    mail_delivery: "Spr\xe1vu sa n\xe1m nepodarilo odosla\u0165.",
    blocked_content: "Spr\xe1vu sa nepodarilo odosla\u0165. Ak obsahuje odkaz na webov\xfa str\xe1nku, sk\xfaste ho pros\xedm vynecha\u0165."
};
/**
 * Shows the outcome of a form submission. The handlers redirect back with
 * ?sent=true|false plus, on failure, a &reason= so the visitor is told what to do
 * next instead of a bare "something went wrong".
 */ function $d389dc1f54eb134c$var$_showFormResult(scope) {
    const urlParams = new URLSearchParams(window.location.search);
    const sent = urlParams.get("sent");
    const prefix = scope === "" ? "" : scope + " ";
    const errorEl = document.querySelector(prefix + "[role=alert].error");
    const successEl = document.querySelector(prefix + "[role=alert].success");
    if (sent === "false") {
        const reason = $d389dc1f54eb134c$var$FORM_ERROR_REASONS[urlParams.get("reason") ?? ""];
        const reasonEl = errorEl?.querySelector(".error-reason");
        if (reason && reasonEl) reasonEl.textContent = reason;
        errorEl?.classList.remove("hidden");
        successEl?.classList.add("hidden");
    } else if (sent !== null) {
        errorEl?.classList.add("hidden");
        successEl?.classList.remove("hidden");
    } else {
        errorEl?.classList.add("hidden");
        successEl?.classList.add("hidden");
    }
}
function $d389dc1f54eb134c$var$_onLoad() {
    // The hosting serves every page with a trailing slash too, e.g.
    // /aktualizacia-licencie/, so compare against the path without it.
    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    if (path == "/aktualizacia-licencie" || path == "/aktualizacia-licencie.html") {
        const licenseSelect = document.getElementById("license");
        if (licenseSelect != null) {
            let license = "coverage.y26";
            if (window.location.hash === "#license-coverage-y26") license = "coverage.y26";
            licenseSelect.value = license;
        }
        $d389dc1f54eb134c$var$_showFormResult("");
    }
    if (path == "/" || path == "/index" || path == "/index.html") $d389dc1f54eb134c$var$_showFormResult("#contact");
    const headerContainerEl = $d389dc1f54eb134c$var$_findHeaderElement();
    const headerBannerEl = $d389dc1f54eb134c$var$_findHeaderBannerElement();
    if (headerContainerEl) {
        const headerContainerHeight = headerContainerEl.offsetHeight + (headerBannerEl ? headerBannerEl.offsetHeight : 0);
        const pageTitle = document.querySelector("body > header + h1.page-title");
        let currentHeaderPageTitleTimeoutHandle;
        const resetTimerCallback = (restart, timeoutCallback)=>{
            if (currentHeaderPageTitleTimeoutHandle) window.clearTimeout(currentHeaderPageTitleTimeoutHandle);
            if (restart && timeoutCallback) currentHeaderPageTitleTimeoutHandle = window.setTimeout(()=>timeoutCallback(), 3000);
        };
        window.addEventListener("scroll", ()=>$d389dc1f54eb134c$var$_initializeMenu(headerContainerHeight), false);
        window.addEventListener("scroll", ()=>$d389dc1f54eb134c$var$_initializeHeader(resetTimerCallback, pageTitle), false);
        $d389dc1f54eb134c$var$_initializeMenu(headerContainerHeight);
        $d389dc1f54eb134c$var$_initializeHeader(resetTimerCallback, pageTitle);
    //
    // const menuElements = document.querySelectorAll("#main-menu a.menu-item, #main-menu ul.dropdown-menu");
    // for (let i = 0; i < menuElements.length; i++) {
    //     const menuElement = menuElements[i];
    //     if (menuElement.tagName === "A") {
    //         if (menuElement.nextElementSibling?.tagName === "UL") {
    //             menuElement.addEventListener("click", () => {
    //                 console.error(menuElement.nextElementSibling?.classList);
    //                 const isOpen = menuElement.nextElementSibling?.classList.contains("open");
    //                 if (isOpen) {
    //                     menuElement.nextElementSibling?.classList.remove("open");
    //                 } else {
    //                     menuElement.nextElementSibling?.classList.add("open");
    //                 }
    //             });
    //         }
    //     }
    // }
    }
}
window.addEventListener("load", $d389dc1f54eb134c$var$_onLoad, false);
//////////
/* plain JS slideToggle https://github.com/ericbutler555/plain-js-slidetoggle */ // Plain vanilla JavaScript version of jQuery's slideToggle(), slideUp(), and slideDown() functions.
HTMLElement.prototype.slideToggle = function(duration, callback) {
    if (this.clientHeight === 0) $d389dc1f54eb134c$var$_s(this, duration, callback, true);
    else $d389dc1f54eb134c$var$_s(this, duration, callback);
};
HTMLElement.prototype.slideUp = function(duration, callback) {
    $d389dc1f54eb134c$var$_s(this, duration, callback);
};
HTMLElement.prototype.slideDown = function(duration, callback) {
    $d389dc1f54eb134c$var$_s(this, duration, callback, true);
};
function $d389dc1f54eb134c$var$_s(el, duration, callback, isDown) {
    if (typeof duration === "undefined") duration = 400;
    if (typeof isDown === "undefined") isDown = false;
    el.style.overflow = "hidden";
    if (isDown) el.style.display = "block";
    var elStyles = window.getComputedStyle(el);
    var elHeight = parseFloat(elStyles.getPropertyValue("height"));
    var elPaddingTop = parseFloat(elStyles.getPropertyValue("padding-top"));
    var elPaddingBottom = parseFloat(elStyles.getPropertyValue("padding-bottom"));
    var elMarginTop = parseFloat(elStyles.getPropertyValue("margin-top"));
    var elMarginBottom = parseFloat(elStyles.getPropertyValue("margin-bottom"));
    var stepHeight = elHeight / duration;
    var stepPaddingTop = elPaddingTop / duration;
    var stepPaddingBottom = elPaddingBottom / duration;
    var stepMarginTop = elMarginTop / duration;
    var stepMarginBottom = elMarginBottom / duration;
    var start;
    function step(timestamp) {
        if (start === undefined) start = timestamp;
        var elapsed = timestamp - start;
        if (isDown) {
            el.style.height = stepHeight * elapsed + "px";
            el.style.paddingTop = stepPaddingTop * elapsed + "px";
            el.style.paddingBottom = stepPaddingBottom * elapsed + "px";
            el.style.marginTop = stepMarginTop * elapsed + "px";
            el.style.marginBottom = stepMarginBottom * elapsed + "px";
        } else {
            el.style.height = elHeight - stepHeight * elapsed + "px";
            el.style.paddingTop = elPaddingTop - stepPaddingTop * elapsed + "px";
            el.style.paddingBottom = elPaddingBottom - stepPaddingBottom * elapsed + "px";
            el.style.marginTop = elMarginTop - stepMarginTop * elapsed + "px";
            el.style.marginBottom = elMarginBottom - stepMarginBottom * elapsed + "px";
        }
        if (elapsed >= duration) {
            el.style.height = "";
            el.style.paddingTop = "";
            el.style.paddingBottom = "";
            el.style.marginTop = "";
            el.style.marginBottom = "";
            el.style.overflow = "";
            if (!isDown) el.style.display = "none";
            if (typeof callback === "function") callback();
        } else window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
}
// JS
const $d389dc1f54eb134c$var$overlays = document.querySelector(".overlay");
const $d389dc1f54eb134c$var$body = document.querySelector("body");
const $d389dc1f54eb134c$var$menuBtn = document.querySelector(".menu-btn");
const $d389dc1f54eb134c$var$menuItems = document.querySelector(".menu-items");
// Add class to a tag and ul tag if li parent contains sub-menu
const $d389dc1f54eb134c$var$liElems = document.querySelectorAll(".menu-items li");
$d389dc1f54eb134c$var$liElems.forEach((elem)=>{
    elem.childNodes.forEach((node)=>{
        if (node.nodeName === "A" && (!node.nextElementSibling || node.nextElementSibling.nodeName !== "UL" || !node.nextElementSibling?.classList.contains("dropdown-menu"))) node.addEventListener("click", (e)=>{
            if ($d389dc1f54eb134c$var$menuBtn?.classList.contains("open")) $d389dc1f54eb134c$var$toggle();
        });
    });
    const childrenElems = elem.querySelectorAll(".dropdown-menu");
    if (childrenElems.length > 0) {
        elem.firstElementChild?.classList.add("expand-btn");
        elem.classList.add("dropdown");
    }
});
function $d389dc1f54eb134c$var$toggle() {
    // disable overflow body
    $d389dc1f54eb134c$var$body?.classList.toggle("overflow");
    // dark background
    $d389dc1f54eb134c$var$overlays?.classList.toggle("overlay--active");
    // add open class
    $d389dc1f54eb134c$var$menuBtn?.classList.toggle("open");
    $d389dc1f54eb134c$var$menuItems?.classList.toggle("open");
}
// Open Menu Mobile
$d389dc1f54eb134c$var$menuBtn?.addEventListener("click", (e)=>{
    e.stopPropagation();
    $d389dc1f54eb134c$var$toggle();
});
// Closes when the Esc key is pressed
window.onkeydown = function(event1) {
    const key = event1.key; // const {key} = event; in ES6+
    const active = $d389dc1f54eb134c$var$menuItems?.classList.contains("open");
    if (key === "Escape" && active) $d389dc1f54eb134c$var$toggle();
};
// Closes when clicked outside the area
document.addEventListener("click", (e)=>{
    let target = e.target, its_menu = target === $d389dc1f54eb134c$var$menuItems || $d389dc1f54eb134c$var$menuItems?.contains(target), its_hamburger = target === $d389dc1f54eb134c$var$menuBtn, menu_is_active = $d389dc1f54eb134c$var$menuItems?.classList.contains("open");
    if (!its_menu && !its_hamburger && menu_is_active) $d389dc1f54eb134c$var$toggle();
});
// Mobile menu expand
const $d389dc1f54eb134c$var$expandBtn = document.querySelectorAll(".expand-btn");
$d389dc1f54eb134c$var$expandBtn.forEach((btn)=>{
    btn.addEventListener("click", (e)=>{
        if (window.innerWidth <= 1024) {
            // Prevent Default Anchor Click Behavior
            event.preventDefault();
            btn.classList.toggle("open");
            btn.nextElementSibling?.slideToggle(300);
        }
    });
});
window.addEventListener("resize", ()=>{
    if (window.innerWidth > 1024) {
        // Off menu mobile on desktop
        if ($d389dc1f54eb134c$var$menuBtn?.classList.contains("open")) $d389dc1f54eb134c$var$toggle();
        // Change arrow menu on Desktop
        for(var i = 0; i < $d389dc1f54eb134c$var$expandBtn.length; i += 1)$d389dc1f54eb134c$var$expandBtn[i].classList.remove("open");
        // Off SlideToggle Menu on Desktop
        const dropdownMenu = document.querySelectorAll(".menu-items .dropdown-menu");
        for(var i = 0; i < dropdownMenu.length; i += 1)dropdownMenu[i].style.display = "";
    }
});


//# sourceMappingURL=index.9d04d200.js.map
